// Short display form of the auto-created protection roles. Display only: the stored
// name is unchanged, so anything matching on it must keep using `role.name`.
const SHORT = { network: 'n', node: 'd', station: 's' };

export function roleLabel(name) {
  const m = /^protect:(network|node|station):(.+)$/.exec(name || '');
  return m ? `r:${SHORT[m[1]]}:${m[2]}` : name;
}
